import { render, staticRenderFns } from "./DetailSurgeryNovoeight.vue?vue&type=template&id=401e20a3&scoped=true&"
import script from "./DetailSurgeryNovoeight.vue?vue&type=script&lang=js&"
export * from "./DetailSurgeryNovoeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e20a3",
  null
  
)

export default component.exports